import PasswordModal from 'components/Modal/PasswordModal';
import UserModal from 'components/Modal/UserModal';
import ChangelogModal from 'components/Modal/ChangelogModal';
import Preloader from 'components/Preloader';
import React, { ReactNode, useEffect } from 'react';
import { useSelector } from 'react-redux';
import selectors from 'state/selectors';
import styled from 'styled-components/macro';
import { headerHeight } from 'utils/styleConstants';
import Menu from '../Menu';
import Header from '../PageHeader/LayoutHeader';
import Sidebar from '../Sidebar/Sidebar';
import useChatbot from 'hooks/useChatbot';
import { moduleProgramCode } from 'utils/constants';
import WalkthroughOverlay from 'components/Chatbot/Components/Walkthrought';
import Chatbot from 'components/Chatbot';

const Main = styled.main<{ isMenuOpen: boolean }>`
  position: relative;
  overflow: auto;
  background-color: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey2 : theme.colorPalette.white};
  position: fixed;
  top: 70px;
  width: calc(100% - 63px);
  left: 37px;
  min-height: calc(100vh - 70px);
  filter: ${({ isMenuOpen }) => (isMenuOpen ? 'brightness(0.4)' : 'none')};
  transition: filter 0.3s linear;
  margin-left: 26px;
  pointer-events: ${({ isMenuOpen }) => (isMenuOpen ? 'none' : 'auto')};
`;

const Grid = styled.div<{ isMenuOpen: boolean }>`
  display: grid;
  grid-template-columns: ${({ isMenuOpen }) => (isMenuOpen ? 230 : 37)}px auto;
  grid-template-rows: ${headerHeight}px calc(100vh - ${headerHeight}px);
  grid-template-areas:
    'header header'
    'menu main';
  transition: grid-template-columns 0.3s ease;

  > Header {
    grid-area: header;
  }
`;

interface Props {
  children: ReactNode;
}

const Layout = (props: Props) => {
  const isMenuOpen = useSelector(selectors.app.getMenu);

  const { isShowen, fetchInitialData, checkPrivileges } = useChatbot();
  const userPrograms = useSelector(selectors.user.getUserPrograms)?.programs;

  useEffect(() => {
    // check if bot is enabled for the user
    if (userPrograms?.find(({ idProgram }) => idProgram === moduleProgramCode.chatbot)) {
      fetchInitialData();
      checkPrivileges();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userPrograms]);

  return (
    <>
      <Grid isMenuOpen={isMenuOpen}>
        <Preloader area="app" />
        <Preloader area="leftBottom" />
        <Header />
        <Sidebar>
          <Preloader area="menu" />
          <Menu />
        </Sidebar>
        <Main isMenuOpen={isMenuOpen}>
          <Preloader area="module" />
          {props.children}
          {isShowen && <Chatbot />}
        </Main>
        <UserModal />
        <PasswordModal />
        <ChangelogModal />
      </Grid>

      {isShowen && <WalkthroughOverlay />}
    </>
  );
};

export default Layout;
